import React from 'react'
import PropTypes from 'prop-types'

const DIRECTIONS = {
  left: 'Left',
  right: 'Right',
  up: 'Up',
  down: 'Down',
}

const EVENTS_TYPES = {
  touchStart: 'touchstart',
  touchMove: 'touchmove',
  touchEnd: 'touchend',
  mouseMove: 'mousemove',
  mouseUp: 'mouseup'
}

const initialState = {
  xy: [0, 0],
  swiping: false,
  eventData: null
}

export default class Swipeable extends React.Component {
  constructor(props) {
    super(props)
    this.state = initialState

    this.touchEvents = [
      [EVENTS_TYPES.touchStart, this.handleTouchStart], 
      [EVENTS_TYPES.touchMove, this.handleMove], 
      [EVENTS_TYPES.touchEnd, this.handleTouchEnd]]

    this.mouseEvents = [
      [EVENTS_TYPES.mouseMove, this.handleMove], 
      [EVENTS_TYPES.mouseUp, this.handleMouseUp]]
  }

  componentDidMount() {
    if (this.props.trackTouch) {
      this.addEventsListeners({events: this.touchEvents})
    }
  }

  componentWillUnmount() {
    if (this.props.trackTouch) {
      this.removeEventsListeners({events: this.touchEvents})
    }
  }

  addEventsListeners = ({ events }) => {
    events.forEach(([e, h]) => this.swipeElement.addEventListener(e, h)) 
  }

  removeEventsListeners = ({ events }) => {
    events.forEach(([e, h]) => this.swipeElement.removeEventListener(e, h))
  }
  
  getDirection = (absX, absY, deltaX, deltaY) => {
    if (absX > absY) {
      if (deltaX > 0) {
        return DIRECTIONS.left
      }
      return DIRECTIONS.right
    } else if (deltaY > 0) {
      return DIRECTIONS.up
    }
    return DIRECTIONS.down
  }

  handleMouseUp = (event) => {
    this.removeEventsListeners({events: this.mouseEvents})
    this.handleTouchEnd(event)
  }

  handleTouchStart = (event) => {
    if (event.touches && event.touches.length > 1) return
      
    this.props.trackMouse && this.addEventsListeners({events: this.mouseEvents})

    const { clientX, clientY } = event.touches ? event.touches[0] : event
    const xy = [clientX, clientY]
    this.setState({ xy })
   }

  handleMove = (event) => {
    if (!this.state.xy[0] || !this.state.xy[1] || (event.touches && event.touches.length > 1)) {
      return
    }

    const { clientX, clientY } = event.touches ? event.touches[0] : event
    const [x, y] = [clientX, clientY]
    const deltaX = this.state.xy[0] - x
    const deltaY = this.state.xy[1] - y
    const absX = Math.abs(deltaX)
    const absY = Math.abs(deltaY)

    // if swipe is under threshold and we have not started to track a swipe: skip update
    if (this.props.swipeThreshold > Math.max(absX, absY) && !this.state.swiping) {
      return
    } 

    const dir = this.getDirection(absX, absY, deltaX, deltaY)
    const eventData = { ...this.state.eventData, event, absX, absY, deltaX, deltaY, dir }

    this.props.onSwiping && this.props.onSwiping(eventData)

    // track if a swipe is cancelable(handler for swiping or swiped(dir) exists)
    // so we can call preventDefault if needed
    let cancelablePageSwipe = false
    if (this.props.onSwiping || this.props.onSwiped || this.props[`onSwiped${dir}`]) {
      cancelablePageSwipe = true
    }

    if (cancelablePageSwipe && this.props.preventDefaultTouchmoveEvent && this.props.trackTouch && event.cancelable) {
      event.preventDefault()
    }

    this.setState({ eventData, swiping: true })
  }

  handleTouchEnd = (event) => {
    if (!this.state.swiping) {
      return
    }
    const eventData = { ...this.state.eventData, event }
    this.props.onSwiped && this.props.onSwiped(eventData)
    this.props[`onSwiped${eventData.dir}`] && this.props[`onSwiped${eventData.dir}`](eventData)
    this.setState({ ...initialState })
  }

  render() {
    return (
      <div ref={ref => this.swipeElement = ref} className={this.props.className}>
        {this.props.children}
      </div>
    )
  }
}

Swipeable.propTypes = {
  onSwiped: PropTypes.func,
  onSwiping: PropTypes.func,
  onSwipedUp: PropTypes.func,
  onSwipedRight: PropTypes.func,
  onSwipedDown: PropTypes.func,
  onSwipedLeft: PropTypes.func,
  swipeThreshold: PropTypes.number,
  preventDefaultTouchmoveEvent: PropTypes.bool,
  trackMouse: PropTypes.bool,
  trackTouch: PropTypes.bool,
}

Swipeable.defaultProps = {
  preventDefaultTouchmoveEvent: false,
  swipeThreshold: 10,
  trackMouse: false,
  trackTouch: true
}